import { BoxV2 as Box, Button, Flex } from 'portal-commons';
import { FunctionComponent } from 'react';
import { faHandsClapping } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Modal } from '@/components';

interface RcsCampaignRegisteredModalProps {
  open?: boolean;
  onClose?: () => void;
}

const Title: FunctionComponent = ({ children }) => (
  <Box
    sx={{
      marginTop: '12px',
      marginBottom: '20px',
      fontWeight: 800,
      fontSize: '20px',
      lineHeight: 'normal',
    }}
  >
    {children}
  </Box>
);

const Content: FunctionComponent = ({ children }) => (
  <Box
    sx={{
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: 'normal',
    }}
  >
    {children}
  </Box>
);

const RcsCampaignRegisteredModal: FunctionComponent<
  RcsCampaignRegisteredModalProps
> = ({ open, onClose }) => {
  return (
    <Modal open={open}>
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: 'center',
          color: 't.black80',
        }}
      >
        <Box
          sx={{
            color: 't.blue700',
            fontWeight: 300,
            fontSize: '64px',
            lineHeight: 'normal',
          }}
        >
          <FontAwesomeIcon icon={faHandsClapping} />
        </Box>
        <Title>RCS Campaign Registered</Title>
        <Content>
          <Box sx={{ fontWeight: 600 }}>
            Your campaign will be shared to your upstream DCA.
          </Box>
          <br />
          <Box>
            Please note that the campaign will be submitted for verification
            only after all DCAs have accepted it.
          </Box>
          <br />
          <Box>
            Additionally, your brand must have a completed RCS vet, and your
            logo and banner assets verified before the vetting authority can
            proceed.
          </Box>
        </Content>
        <Box sx={{ marginTop: '28px', marginBottom: '37px' }}>
          <Button onClick={onClose}>Close</Button>
        </Box>
      </Flex>
    </Modal>
  );
};

export default RcsCampaignRegisteredModal;
